import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/news', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/news/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/news', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/news/${data.news_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadfile = data => {
  return httpClient
    .post('/api/news/upload-image', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const readImage = id => {
  return httpClient
    .get(`/api/news/${id}/feature-image`, {
      responseType: 'arraybuffer'
    })
    .then(response =>
      Promise.resolve(
        `data:image/jpg;base64,${new Buffer(response.data, 'binary').toString(
          'base64'
        )}`
      )
    )
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/news/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const newImageContent = data => {
  return httpClient
    .post('/api/news/image-contents', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const sendNotification = id => {
  return httpClient
    .get(`/api/news/${id}/send-notification`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  uploadfile,
  readImage,
  newImageContent,
  sendNotification
}
